import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE, getPhone } from '../components/health/healthShared';
import HealthHome from '../components/health/HealthHome';
import HealthAssessment from '../components/health/HealthAssessment';
import MyHealth from '../components/health/MyHealth';
import EatBetter from '../components/health/EatBetter';
import MoveSection from '../components/health/MoveSection';
import SleepRecover from '../components/health/SleepRecover';
import MyDay from '../components/health/MyDay';
import HealthCoach from '../components/health/HealthCoach';

export default function GynovateHealthPage() {
  const navigate = useNavigate();
  const [view, setView] = useState('home');
  const [profile, setProfile] = useState(null);
  const [snapshot, setSnapshot] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [myDayPreset, setMyDayPreset] = useState(null);

  useEffect(() => {
    const phone = getPhone();
    if (!phone) { setLoaded(true); return; }
    axios.get(`${API_BASE}/api/health-hub/profile/${encodeURIComponent(phone)}`)
      .then((res) => {
        if (res.data.exists) { setProfile(res.data.profile); setSnapshot(res.data.snapshot); }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const goHome = () => { setView('home'); setMyDayPreset(null); };

  const onSaved = (p, s) => { setProfile(p); setSnapshot(s); setView('home'); };

  const gate = (target) => {
    if (!profile && ['myhealth', 'sleep'].includes(target)) { setView('assessment'); return; }
    setView(target);
  };

  const openMyDay = (dayType) => { setMyDayPreset(dayType); setView('myday'); };

  return (
    <div className="min-h-screen" style={{ background: '#F6F4EC' }} data-testid="gynovate-health-page">
      {/* Top bar */}
      <div className="sticky top-0 z-20 backdrop-blur-md border-b border-[#E8EADE]" style={{ background: 'rgba(246,244,236,0.85)' }}>
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
          <button onClick={() => (view === 'home' ? navigate('/chat') : goHome())} data-testid="health-topbar-back" className="text-sm font-bold text-[#2E4A3B] flex items-center gap-1.5">
            ← {view === 'home' ? 'Gynovate' : 'Health Home'}
          </button>
          <div className="flex items-center gap-1.5">
            <span className="text-base">🌿</span>
            <span className="text-xs font-black tracking-[0.2em] uppercase text-[#2E4A3B]">Gynovate Health</span>
          </div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 py-5 pb-16">
        {!loaded ? (
          <div className="py-24 text-center text-sm text-[#9AA594] animate-pulse" data-testid="health-loading">Loading your dashboard…</div>
        ) : (
          <>
            {view === 'home' && <HealthHome profile={profile} snapshot={snapshot} go={gate} onMyDay={openMyDay} />}
            {view === 'assessment' && <HealthAssessment profile={profile} onSaved={onSaved} onBack={goHome} />}
            {view === 'myhealth' && <MyHealth profile={profile} snapshot={snapshot} go={setView} onBack={goHome} onChecklistSaved={(items) => setProfile((p) => ({ ...p, checklist: items }))} />}
            {view === 'eat' && <EatBetter onBack={goHome} profile={profile} onPrefsSaved={(l, d) => setProfile((p) => (p ? { ...p, food_likes: l, food_dislikes: d } : p))} />}
            {view === 'move' && <MoveSection onBack={goHome} />}
            {view === 'sleep' && <SleepRecover profile={profile} snapshot={snapshot} onBack={goHome} />}
            {view === 'myday' && <MyDay preset={myDayPreset} onBack={goHome} />}
            {view === 'coach' && <HealthCoach onBack={goHome} />}
          </>
        )}
      </div>
    </div>
  );
}
